import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getFormAction } from "../../Actions/FormAction/FormAction";
import { getVisitAction } from "../../Actions/VisitAction/VisitAction";
import ProfileFollowUp from "./ProfileFollowUp";
import ProfilePatient from "../Patient/EachVisit/ProfilePatient";
import LoadingPage from "../Loading/LoadingPage";
import { IoIosArrowBack } from "react-icons/io";
import { IoArrowBackOutline } from "react-icons/io5";

const FollowUpVisit = () => {
  const { id: patient_id } = useParams();
  const dispatch = useDispatch();
  const getForm = useSelector((state) => state.getForm);
  const { forms } = getForm;
  const [activeTab, setActiveTab] = useState(0);
  useEffect(() => {
    dispatch(getFormAction([2]));
    dispatch(getVisitAction(patient_id));
  }, []);

  const getVisit = useSelector((state) => state.getVisit);
  const { visits, loading } = getVisit;
  const tabs = [
    {
      title: "Profile",
      content: <ProfilePatient />,
    },
    ...visits.map((visit) => ({
      title: visit.created_at.split("T")[0],
      content: (
        <ProfileFollowUp
          key={visit.id}
          visit={visit}
          affirasOfSurgery={visit.affiars_of_surgery}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          forms={forms}
        />
      ),
    })),
  ];
  useEffect(() => {
    setActiveTab(0);
  }, []);
 const navigate=useNavigate();
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          <div className="m-auto w-[97%] mt-5  text-gray-100">
            <button onClick={()=>navigate(-1)} className="bg-slate-800 px-1 group py-1 items-center rounded-sm shadow-md hover:bg-slate-950 flex gap-10 duration-500 ">
              Back 
              <p className="group-hover:-translate-x-1 duration-500"><IoArrowBackOutline /></p>
            </button>
          </div>
          <div className=" mt-4 px-2 flex flex-col lg:flex lg:flex-row gap-4 m-auto bg-white  rounded-sm shadow-lg w-[97%]">
            <div className="lg:w-2/12 w-11/12 m-auto  lg:ml-4 mt-4">
              <div className="bg-gray-100 rounded-md">
                <div className="flex flex-col items-center ">
                  {tabs.map((tab, index) => (
                    <button
                      key={index}
                      className={` py-2 rounded focus:outline-none ${
                        activeTab === index
                          ? "bg-slate-800 w-full text-white"
                          : "bg-gray-200 w-full text-gray-700"
                      }`}
                      onClick={() => setActiveTab(index)}
                    >
                      {tab.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="w-full">{tabs[activeTab].content}</div>
          </div>
        </>
      )}
    </>
  );
};
export default FollowUpVisit;
